import React from 'react';
import { connect } from 'react-redux';
import SideAccordion from './SideAccordion';

const SessionInformation = () => {
	return (
		<>
			<div className="mb-4">
				<SideAccordion
					title={'Tune in'}
					component={
						<div className="text-center">
							Thursday 26 March 2021<p>9am to 11am</p>
						</div>
					}
				/>
			</div>
		</>
	);
};

const mapStateToProps = () => {
	return {};
};
const dispatchProps = {};

export default connect(mapStateToProps, dispatchProps)(SessionInformation);
